import * as globalVars from 'settings/globalVars';
import axios from 'axios';

export function getInstanceForLogin() {
    var instance = axios.create({
        baseURL: globalVars.getCalAmpBaseUri(),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
        },
        crossdomain: true,
        withCredentials: true,
        xhrFields: {
            'withCredentials': 'true'
        }
    });
    return instance;
}

export function getInstance() {
    var instance = axios.create({
        baseURL: globalVars.getCalAmpBaseUri(),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            'calamp-services-app': globalVars.getCalAmpAppKey(),
        },
        crossdomain: true,
        withCredentials: true,
        xhrFields: {
            'withCredentials': 'true'
        }
    });

    return instance;
}

export function GetSourceCancelToken() {
    const CancelToken = axios.CancelToken;
    return CancelToken.source();
}



// WEBPACK FOOTER //
// ./src/services/apis/calAmp/httpHolder.js